module.exports = __webpack_public_path__ + "img/skip-foward.0e83c7c5.svg";